module.exports = __webpack_public_path__ + "static/media/uwindsor_logo_2.6b3ee811.jpeg";